export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

export const nameRegex = /^(?!\d+$)[A-Za-z0-9'`-]+$/;

export const businessNameRegex = /^(?!\d+$)(?! )[A-Za-z0-9&.,'’\- ]{1,99}$/;

export const alphaNumericRegex = /^[a-zA-Z0-9]+$/;

export const nonZeroNumber = /^(?=.*[1-9])\d*(?:\.\d+)?$/;

export const noLeadingSpecialChar = /^[a-zA-Z0-9]/;

export const currencyRegex = /^\d{1,6}(\.\d{1,4})?$/;

export const imageValidate = /\.(jpg|jpeg|png|gif|bmp)$/i;

export const pdfValidate = /\.pdf$/i;

export const docsValidate = /\.(doc|docx)$/i;

export const isValidDecimal = /^(?=.*[1-9])\d*(?:\.\d*)?$/;

export const validDecimalUptoTwoDigits =
  /^(?:100(?:\.0{1,2})?|(?:[1-9]?\d|0)(?:\.\d{1,2})?)$/;

export const CR_VAT_ALPHANUMERIC_REGEX = /^[A-Za-z0-9]{5,25}$/;

export const zeroIncludedNumber = /^(?:[0-9]\d*|0\.\d*[1-9]\d*)$/;

export const caratTypeRegex = /^(1[0-9]|2[0-4]|10)$/;

export const isValidNumber = /^(?=0*[1-9]\d*$)\d+$/;

export const numberUptoThreeDecimal = /^(?!0+(?:\.0+)?$)\d+(\.\d{1,3})?$/;

export const percentageRegex =
  /^(?:0*[1-9]?\d(?:\.\d{1,2})?|0*100(?:\.0{1,2})?)$/;
